import { render } from "./monitoring.coreos.com.alertmanagerconfig.vue?vue&type=template&id=398401e2&scoped=true"
import script from "./monitoring.coreos.com.alertmanagerconfig.vue?vue&type=script&lang=js"
export * from "./monitoring.coreos.com.alertmanagerconfig.vue?vue&type=script&lang=js"

import "./monitoring.coreos.com.alertmanagerconfig.vue?vue&type=style&index=0&id=398401e2&lang=scss&scoped=true"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398401e2"]])

export default __exports__